import { BLOG_BASE } from '../../../utils/blogRoutes.js';

// The dashboard's own mount point for the guides.
//
// Deliberately NOT /blogs: that path belongs to the public, prerendered,
// indexed route, and the authenticated router is a separate tree. Two routes
// with the same path in different trees is exactly the ambiguity that makes
// "why did this link go somewhere else" bugs.
export const DASHBOARD_BLOG_BASE = '/guides';

export const dashboardBlogSlugPath = (slug) => `${DASHBOARD_BLOG_BASE}/${slug}`;

// The shared body components emit public hrefs (/blogs/<slug>) because that is
// what a crawler must see on the public pages. Inside the dashboard those have
// to be rewritten, or an in-app link would leave the shell and bounce off the
// authenticated router's catch-all.
export const dashboardBlogPath = (publicHref) =>
  publicHref.startsWith(`${BLOG_BASE}/`)
    ? `${DASHBOARD_BLOG_BASE}/${publicHref.slice(BLOG_BASE.length + 1)}`
    : publicHref;
